module.exports = __webpack_public_path__ + "img/SHGUC.5003a542.jpg";